import React, { useState, useEffect } from 'react';
import { socket } from '../../../socket';
import { Nav, Card, Col, Form, Row, Tab, Tabs, Button, Spinner, Modal } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import NineDotMenu from './NineDotMenu';
import { Dropdown } from 'react-bootstrap';
import ThemeControlDropdown from './ThemeControlDropdown';
import paths from 'routes/paths';
import team3 from 'assets/img/team/avatar.png';
import Avatar from 'components/common/Avatar';
import NeedHelpForm from 'components/common/NeedHelpForm';
import html2canvas from 'html2canvas';
import PharmacyChangelogManager from 'components/admin/drugs/pharmacy/PharmacyChangelogManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import axios from 'helpers/api';
import { toast } from 'react-toastify';


const TopNavRightSideNavItem = () => {
  
  const [show, setShow] = useState(false);
  const [screenshot, setScreenshot] = useState(null);
  // Function to capture screenshot before opening modal
  const captureScreenshot = async () => {
    const element = document.documentElement; // Capture full page
    const canvas = await html2canvas(element, { useCORS: true });
    const image = canvas.toDataURL('image/png'); // Convert to base64
    setScreenshot(image);
    setShow(true);
  };
  const [showChangelogManager, setShowChangelogManager] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const routeToNotification = () => {
    navigate(paths.notification);
  }

  const [count, setCount] = useState(Number(localStorage.getItem("notificationCount") || 0));

  const logoutRender = async () => {
    setIsLoggingOut(true);
    let tokenStr = localStorage.getItem("accessToken");
    axios.post(`${process.env.REACT_APP_SERVER_URL}/users/logout`, {}, { headers: { Authorization: `Bearer ${tokenStr}` } })
      .then((res) => {
        toast.success(res.data.message);
        localStorage.clear();
        navigate(paths.pelMedsLogin);
      })
      .catch((err) => {
        if (err.response.data.errorCode === 1450
          || err.response.data.errorCode === 1451
        ) {
          toast.error(err.response.data.message);
          localStorage.clear();
          navigate(paths.pelMedsLogin);
        } else {
          toast.error(err.response.data.message);
        }
      })
      .finally(() => {
        setIsLoggingOut(false);
      });
  }

  useEffect(() => {
    const tokenStr = localStorage.getItem("accessToken");
    socket.emit('getLatestNotification', { });

    socket.on('newNotifications', async (data) => {
      console.log('Received newNotifications event', data);
      localStorage.setItem("notificationCount", data.notificationsCount);
      setCount(data.notificationsCount);

    });

  }, []);
  return (
    <>
      {isLoggingOut && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px'
          }}
        >
          <Spinner animation="border" variant="light" style={{ width: '3rem', height: '3rem' }} />
          <span style={{ color: '#fff', fontSize: '1rem', fontWeight: 500 }}>
            Logging out...
          </span>
        </div>
      )}

      <Nav
        navbar
        className="navbar-nav-icons ms-auto flex-row align-items-center"
        as="ul"
      >
        <Link className="me-3" to="#" onClick={captureScreenshot}
          state={{
            triggeredBy: "someAction"
          }}>Contact Us</Link>
        {show && <NeedHelpForm show={show} handleClose={() => setShow(false)} screenshot={screenshot} />}
        {/* <Link to={"#"}  onClick={() => (setShow(true))}>Contact Us</Link> */}
        {(Number(localStorage.getItem('roleId')) > 3 && Number(localStorage.getItem('roleId')) != 6) &&  (
          <Nav.Item as="li" className="me-2">
            <div className="position-relative cursor-pointer" onClick={routeToNotification}>
              <FontAwesomeIcon icon={faBell} className="fs-5 text-700" />
              <span
                className={`position-absolute top-0 start-100 translate-middle badge rounded-pill ${count > 0 ? 'bg-danger' : 'bg-success'
                  }`}
              >
                {count}
              </span>
            </div>
          </Nav.Item>
        )}

        <NeedHelpForm show={show} handleClose={setShow} />
        <ThemeControlDropdown />
        <Dropdown as="div" align="end">
          <Dropdown.Toggle
            bsPrefix="toggle"
            variant="link"
            className="nav-link dropdown-toggle d-flex align-items-center pe-1"
          >
            <Avatar src={team3} />
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
            <div className="bg-white rounded-2 py-2 dark__bg-1000">
              <Dropdown.Item as={Link} to={paths.UserProfile}>
                View Profile
              </Dropdown.Item>
              {[1, 2, 4].includes(Number(localStorage.getItem('roleId'))) && (
                <Dropdown.Item as={Link} to={paths.defaultSetting}>
                  Mobile Notification & Inventory Settings
                </Dropdown.Item>
              )}
              {Number(localStorage.getItem('roleId')) < 3 && (
                <Dropdown.Item onClick={() => setShowChangelogManager(true)} role="button">
                  Manage Changelog
                </Dropdown.Item>
              )}
              <Dropdown.Item
                onClick={logoutRender}
                className="text-danger d-flex align-items-center gap-2"
                disabled={isLoggingOut}
              >
                {isLoggingOut ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    <span>Logging out...</span>
                  </>
                ) : (
                  'Log Out'
                )}
              </Dropdown.Item>
            </div>
          </Dropdown.Menu>
        </Dropdown>

        <div>{localStorage.getItem("username")}</div>
      </Nav>

      {/* Changelog Manager Modal for Pharmacy / Admin (roleId < 3) */}
      <Modal
        show={showChangelogManager}
        onHide={() => setShowChangelogManager(false)}
        size="xl"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-light">
          <Modal.Title as="h5" className="mb-0">
            Changelog &amp; System Updates Manager
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <PharmacyChangelogManager />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TopNavRightSideNavItem;

